import React, { Suspense } from 'react'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'

const LazyEvidenceControlsListItemMenu = React.lazy(async () => {
  const module = await import('src/pages/Evidence/evidence.components')
  return { default: module.EvidenceControlsListItemMenu }
})

export const EvidenceControlsListItemMenuProxy = ({
  control,
}: {
  control: Control.AsObject
}): JSX.Element => (
  <Suspense fallback={<></>}>
    <LazyEvidenceControlsListItemMenu control={control} />
  </Suspense>
)
